import CheckboxIndicator from './components/checkbox-indicator'
import CheckboxRoot from './components/checkbox-root'

const CheckboxComponent = {
  Root: CheckboxRoot,
  Indicator: CheckboxIndicator
}

export default CheckboxComponent
